/**
 * IgnyVerse — Vanilla JS Enhancements
 * Pure JavaScript: No external libraries, no jQuery.
 */

(function () {
  'use strict';

  function initScrollReveal() {
    // Instantly reveal above-the-fold elements for immediate zero-delay LCP
    document.querySelectorAll('.igny-hero .igny-reveal, .product .igny-reveal, .product-media-container').forEach(function (el) {
      el.classList.add('is-revealed');
    });

    const revealElements = document.querySelectorAll('.igny-reveal:not(.is-revealed)');
    if (!revealElements.length) return;

    if (!('IntersectionObserver' in window)) {
      revealElements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.1,
      }
    );

    revealElements.forEach(function (el) {
      observer.observe(el);
    });

    // Fallback timer: ensure all elements reveal within 600ms even if observer stalls
    setTimeout(function () {
      document.querySelectorAll('.igny-reveal:not(.is-revealed)').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }, 600);
  }

  function initStickyAddToCart() {
    const stickyATC = document.querySelector('.igny-sticky-atc');
    if (!stickyATC) return;

    const sectionId = stickyATC.id ? stickyATC.id.replace('IgnyStickyATC-', '') : '';
    const mainSubmitBtn = document.getElementById('ProductSubmitButton-' + sectionId) || document.querySelector('.product-form__submit');
    if (!mainSubmitBtn) return;

    function handleScroll() {
      const rect = mainSubmitBtn.getBoundingClientRect();
      const isPast = rect.bottom < 0;
      if (isPast) {
        stickyATC.classList.add('is-visible');
        document.body.classList.add('has-sticky-atc');
      } else {
        stickyATC.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-atc');
      }
    }

    let ticking = false;
    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    handleScroll();

    // Subscribe to Dawn variant change events to synchronize price & availability
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        const variant = event.data.variant;
        const stickyBtn = stickyATC.querySelector('.igny-sticky-atc__btn');
        setTimeout(function () {
          const mainPrice = document.querySelector('.product .price__sale .price-item--last, .product .price .price-item--regular');
          const stickyPrice = stickyATC.querySelector('.igny-sticky-atc__price');
          if (mainPrice && stickyPrice) {
            stickyPrice.textContent = mainPrice.textContent.trim();
          }
        }, 50);

        if (stickyBtn) {
          stickyBtn.disabled = !variant.available;
          const textSpan = stickyBtn.querySelector('span');
          if (textSpan) {
            textSpan.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          }
        }
      });
    }
  }

  // While the mobile menu is open, the cart drawer / search must not open.
  function initMenuExclusivity() {
    if (document._ignyMenuExclusive) return;
    document._ignyMenuExclusive = true;
    document.addEventListener(
      'click',
      function (e) {
        const menu = document.getElementById('Details-menu-drawer-container');
        if (!menu || !menu.classList.contains('menu-opening')) return;
        const t = e.target.closest('#cart-icon-bubble, .header__icon--cart, .header__icon--search, .header__icon--account, .header__search summary');
        if (t) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function initCartDrawerListeners() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && (event.source === 'product-form' || event.source === 'quick-add')) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
            drawer.open();
          }
        }
      });
    }
  }

  // Dawn's facets.js swaps #ProductGridContainer innerHTML after every
  // filter/sort. New cards arrive with .igny-reveal (opacity 0) and would
  // stay invisible, so re-run the reveal whenever the grid changes.
  function initGridRerender() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid || grid._ignyObserved || !('MutationObserver' in window)) return;
    grid._ignyObserved = true;
    new MutationObserver(function () {
      grid.querySelectorAll('.igny-reveal:not(.is-revealed)').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }).observe(grid, { childList: true, subtree: true });
  }

  // ---- Body scroll lock -------------------------------------------------
  // Dawn adds body.overflow-hidden (cart) / overflow-hidden-{mobile,tablet,desktop}
  // (menu, filter drawer) and relies on `overflow:hidden`, which iOS Safari
  // ignores. We mirror those classes onto <html> (covers desktop + Android)
  // and, while locked, block touch-scrolling everywhere except inside the
  // open drawer. The header stays sticky and in place.
  var SCROLLABLE_IN_LOCK = '.menu-drawer, .menu-drawer__submenu, cart-drawer-items, .mobile-facets__inner, .drawer__inner';

  function initScrollLock() {
    if (document.documentElement._ignyScrollLock) return;
    document.documentElement._ignyScrollLock = true;
    var html = document.documentElement;
    var body = document.body;
    var startY = 0;

    function wantsLock() {
      var c = body.classList;
      if (c.contains('overflow-hidden')) return true;
      var w = window.innerWidth;
      if (c.contains('overflow-hidden-mobile') && w < 750) return true;
      if (c.contains('overflow-hidden-tablet') && w < 990) return true;
      if (c.contains('overflow-hidden-desktop')) return true;
      return false;
    }

    function onTouchStart(e) {
      startY = e.touches && e.touches.length ? e.touches[0].clientY : 0;
    }

    function onTouchMove(e) {
      if (!html.classList.contains('igny-scroll-locked')) return;
      var scroller = e.target.closest ? e.target.closest(SCROLLABLE_IN_LOCK) : null;
      if (!scroller) {
        e.preventDefault(); // touching the page/overlay: never scroll it
        return;
      }
      // Inside a drawer: allow, but stop rubber-banding at the edges from
      // leaking into the page.
      var y = e.touches && e.touches.length ? e.touches[0].clientY : 0;
      var dy = y - startY;
      var atTop = scroller.scrollTop <= 0;
      var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
      if ((atTop && dy > 0) || (atBottom && dy < 0)) e.preventDefault();
    }

    function apply() {
      var want = wantsLock();
      html.classList.toggle('igny-scroll-locked', want);
    }

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    new MutationObserver(apply).observe(body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', apply, { passive: true });
    apply();
  }

  // ---- Mobile menu state mirror ---------------------------------------
  // The backdrop itself is pure CSS (summary::before). This just mirrors the
  // open state onto <html> for browsers without :has().
  function initMenuState() {
    const details = document.getElementById('Details-menu-drawer-container');
    if (!details || details._ignyMenuState) return;
    details._ignyMenuState = true;
    function sync() {
      document.documentElement.classList.toggle('igny-menu-open', details.classList.contains('menu-opening'));
    }
    new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    sync();
  }

  function init() {
    initScrollLock();
    initMenuState();
    initMenuExclusivity();
    initScrollReveal();
    initStickyAddToCart();
    initCartDrawerListeners();
    initGridRerender();
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run if Shopify Theme Editor triggers section reload
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();


